'use strict';

/*
 * Import styles.css here that WP JS Tool takes care of it
 *    - converts scss to css
 *    - generates build files, etc
 */
import '../css/style.scss';

/*
 * JS modules / classes
 */
import DelayDisplay from "./modules/DelayDisplay";
import SelectPostFromSidebar from "./modules/SelectPostFromSidebar";
import PlayFlexbox from "./modules/PlayFlexbox";
//import AdjustGridHeight from "./modules/AdjustGridHeight";
import AdjustMenuWidth from "./modules/AdjustMenuWidth";

/*
 * Instantiate object of class modules
 */
new DelayDisplay();
new SelectPostFromSidebar();
new PlayFlexbox();
//new AdjustGridHeight();
new AdjustMenuWidth();